import settings from '@/settings'

let enviarNotificacao = (headers, payload) => {
  return fetch(`${settings.fisioApi}/notificacoes/notificacao-admin/`, {
    method: 'POST',
    body: JSON.stringify({
      title: payload.title,
      body: payload.body,
      id_pessoa: payload.id_pessoa,  
      topic: payload.topic           
    }),
    mode: 'cors',
    headers: headers
  })
}

export default {
  enviarNotificacao
}
